import { ToggleTheme } from "@/features"
import styles from "./styles.module.scss"
import { Button } from "@/components/ui/button"
import {
  Archive,
  ChevronRightCircle,
  LogOut,
  Menu,
  UserRound,
} from "lucide-react"
import { useAppSidebarStore } from "../model"
import { useModalStore, useUserStore } from "@/entities"
import { Link } from "react-router-dom"
import { ROUTER_PATHS } from "@/shared/constants/router-paths"
import { Modal } from "@/shared/types"
import { ArchivedContentModal } from "@/widgets/modals"
import { SvgLogo } from "@/shared/ui/svg"
import { HighlightPendingBadge } from "@/features/highlight-pending-badge"

export const LayoutAppHeader = () => {
  const isOpened = useAppSidebarStore(s => s.isOpened)
  const setIsOpened = useAppSidebarStore(s => s.setIsOpened)
  const logout = useUserStore(s => s.logout)
  const email = useUserStore(s => s.email)
  const isGuest = useUserStore(s => s.isGuest)
  const openModal = useModalStore(s => s.openModal)

  const handleOpenArchivedContentModal = () => {
    openModal(Modal.ARCHIVED_CONTENT, <ArchivedContentModal />)
  }

  return (
    <header className={styles.header}>
      <div className={styles.header__inner}>
        <div className={styles.header__inner__left}>
          {!isOpened && (
            <Button
              variant="outline"
              size="icon"
              onClick={() => setIsOpened(true)}
              className={styles.openSidebarButton}
            >
              <ChevronRightCircle size={24} />
            </Button>
          )}

          <div className={styles.mobileMenuWrapper}>
            <Link to={ROUTER_PATHS.APP_LIBRARY}>
              <SvgLogo className="h-10 w-10" />
            </Link>

            <Button
              variant="outline"
              size="icon"
              onClick={() => setIsOpened(true)}
            >
              <Menu />
            </Button>
          </div>

          <HighlightPendingBadge className="ml-3 first:ml-0" />
        </div>
        <div className={styles.header__inner__right}>
          <Link
            to={ROUTER_PATHS.PROFILE}
            title={isGuest ? "Guest profile" : `Profile ${email ?? ""}`}
            aria-label={isGuest ? "Guest profile" : `Profile ${email ?? ""}`}
            className={`${styles.avatar} ${isGuest ? styles.avatar_guest : ""}`}
          >
            {isGuest ? (
              <UserRound size={18} aria-hidden="true" />
            ) : (
              email?.charAt(0)
            )}
          </Link>

          <Button
            variant="outline"
            size="icon"
            onClick={handleOpenArchivedContentModal}
          >
            <Archive />
          </Button>

          <ToggleTheme />
          <Button variant="outline" size="icon" onClick={() => logout()}>
            <LogOut />
          </Button>
        </div>
      </div>
    </header>
  )
}
